import { useEffect, useState } from "react";
import GCBrandSearch from "../../Component/Common/ReuseableComponent/GCBrandSearch";

const BrandSearch = ({}) => { 
   const [sValue, setValue] = useState(''); 
   const [brandBasket, setBrandBasket] = useState([]);
   
   useEffect(() => {
    console.log("brandBasket",brandBasket);
    
   },[brandBasket])
    return (
      <>
      <GCBrandSearch
      xValue={sValue} //main input value
      xOnChange={(e)=>{
        setValue(e.target.value)  //main input onchange
      }}
      basketValue={brandBasket} //Search basket array
      xListValue={brandBasket.map(x => x.Name1).join(", ")} // 2nd main input
      onApply={(selectedObjects) => 
        {
        setBrandBasket(selectedObjects) //array of object
        setValue("")

      }} // <- handle selected names
      />
      </>
    );
  };
  export default BrandSearch;